import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from '@/context';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <ConfigProvider>{children}</ConfigProvider>
    </BrowserRouter>
  );
}
